module.exports = __webpack_public_path__ + "img/logo-min.01604768.svg";